export default __webpack_public_path__ + "static/media/phone.f5b2a548.jpeg";